import { useEffect, useEffectEvent, useRef, useState } from "react";

export interface UseSettledCountAnnouncementOptions {
    isRefreshing: boolean;
    totalCount: number | undefined;
    getMessage: (count: number) => string;
}

export function useSettledCountAnnouncement({ isRefreshing, totalCount, getMessage }: UseSettledCountAnnouncementOptions) {
    const wasRefreshingRef = useRef<boolean>(false);
    const [announcement, setAnnouncement] = useState<string>("");

    const [wasRefreshing, setWasRefreshing] = useState(isRefreshing);
    if (wasRefreshing !== isRefreshing) {
        setWasRefreshing(isRefreshing);

        if (isRefreshing) {
            setAnnouncement("");
        }
    }

    const announceSettledCount = useEffectEvent(() => {
        if (totalCount !== undefined) {
            setAnnouncement(getMessage(totalCount));
        }
    });

    useEffect(() => {
        if (isRefreshing) {
            wasRefreshingRef.current = true;

            return;
        }

        if (wasRefreshingRef.current) {
            wasRefreshingRef.current = false;
            announceSettledCount();
            const timer = setTimeout(() => setAnnouncement(""), 1000);

            return () => clearTimeout(timer);
        }
    }, [isRefreshing]);

    return announcement;
}
